import {useContext} from 'react';

import {ActivitySidebarContext, type ActivitySidebarContextValue} from './ActivitySidebarContext';

export function useActivitySidebar(): ActivitySidebarContextValue {
  const context = useContext(ActivitySidebarContext);

  if (!context) {
    throw new Error('useActivitySidebar must be used within an ActivitySidebarProvider');
  }

  return context;
}
